<template>
  <v-card>
    <v-card-title primary-title class="headline">
      Rete Cablata
    </v-card-title>
    <v-card-text>
      <v-switch 
        true-value="dhcp"
        false-value="static"
        v-model="network.eth0_dhcp" 
        label="DHCP">
      </v-switch>
      <v-slide-y-transition>
        <div v-if="network.eth0_dhcp == 'static'">
          <v-text-field
          v-model="network.eth0_address"
          :label="$t('network-address')"
          required></v-text-field>
          <v-text-field
          v-model="network.eth0_netmask"
          :label="$t('network-netmask')"
          required></v-text-field>
          <v-text-field
          v-model="network.eth0_gateway"
          label="Gateway"
          required></v-text-field>
          <v-text-field
          v-model="network.eth0_dns1"
          label="DNS"
          required></v-text-field>
          <v-text-field
          v-model="network.eth0_dns2"
          label="DNS"
          required></v-text-field>
        </div>
      </v-slide-y-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NetworkSettingsEth0",
  computed: {
    ...mapGetters(["network"])
  },  
};
</script>